import { render, staticRenderFns } from "./course-sales-statistics.vue?vue&type=template&id=11b1fe7e&scoped=true"
import script from "./course-sales-statistics.vue?vue&type=script&lang=js"
export * from "./course-sales-statistics.vue?vue&type=script&lang=js"
import style0 from "./course-sales-statistics.vue?vue&type=style&index=0&id=11b1fe7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b1fe7e",
  null
  
)

export default component.exports